import LoginPage from '@/views/LoginPage'
import PageNotFound from '@/views/errors/PageNotFound'
import * as ROUTES from '@/router/route-names'
import AuthenticatedGuard from '@/router/authenticated-guard'
import store from '@/store/store'

export default [
  {
    path: '/login',
    name: ROUTES.LOGIN_PAGE,
    component: LoginPage,
  },
    // Alps has a lot of material with /policy-login - so this is to help during the transition so that link is still valid
  {
    path: '/policy-login',
    redirect: '/login',
  },
  {
    path: '/',
    name: 'Home',
    redirect: () => {
      // if authenticated, someday, do something else
      if (AuthenticatedGuard.isLoggedIn()) {
        const activeAccount = store.getters.getActiveAccount || {}
        let accountCode = activeAccount.accountCode
        if (accountCode) {
          return { name: ROUTES.DASHBOARD }
        } else {
          if (AuthenticatedGuard.isAnAdmin()) {
            return { name: ROUTES.ADMIN_ACCOUNTS }
          }
          const authedAccounts = AuthenticatedGuard.authedAccounts()
          if (authedAccounts.length === 1) {
            accountCode = authedAccounts[0]
            return `/${accountCode}/dashboard`
          } else {
            return { name: ROUTES.ACCOUNT_SELECTOR }
          }
        }
      }
      return { name: ROUTES.LOGIN_PAGE }
    },
  },
  {
    path: '/register',
    name: ROUTES.REGISTRATION_PAGE,
    component: () => import('../views/RegisterPage.vue'),
    props: true,
  },
  {
    path: '/pre-register',
    name: ROUTES.PRE_REGISTRATION_PAGE,
    component: () => import('../views/PreRegister.vue'),
  },
  {
    path: '/invite/:identifier',
    name: ROUTES.INVITE_PAGE,
    component: () => import('../views/AcceptInvitationPage.vue'),
    props: {
      inviteType: 'account',
    },
  },
  {
    path: '/broker-invite/:identifier',
    name: ROUTES.BROKER_INVITE_PAGE,
    component: () => import('../views/AcceptInvitationPage.vue'),
    props: {
      inviteType: 'broker',
    },
  },
  {
    path: '/password-reset',
    name: ROUTES.FORGOT_PASSWORD,
    component: () => import(/* webpackChunkName: "passwordreset" */ '../views/ForgotPassword.vue'),
  },
  {
    path: '/password-reset/:identifier',
    name: ROUTES.PASSWORD_RESET,
    component: () => import(/* webpackChunkName: "passwordreset" */ '../views/ResetPassword.vue'),
  },
  {
    path: '/help',
    name: ROUTES.NEED_HELP,
    component: () => import('../views/HelpPage.vue'),
  },
  {
    path: '/pricing',
    name: ROUTES.PRICING,
    component: () => import('../views/FerroPricing.vue'),
  },
  {
    path: '/prospect-questionnaire/:jsonFormId/:identifier',
    name: ROUTES.PROSPECT_QUESTIONNAIRE,
    component: () => import('../views/ProspectQuestionnaire.vue'),
  },
  {
    path: '/submission-download/:requestId/:downloadCode',
    name: ROUTES.SUBMISSION_DOWNLOAD,
    component: () => import('../views/SubmissionDownload.vue'),
  },

  {
    path: '/alps-payment-success',
    name: ROUTES.ALPS_PAYMENT_SUCCESS,
    component: () => import('../views/alps/AlpsPaymentSuccess.vue'),
  },
  {
    path: '/404',
    alias: '*',
    name: ROUTES.NOT_FOUND_PAGE,
    component: PageNotFound,
  },
]
